<zc-card title="Sample Blocked Lead Name">
  <zc-card-body></zc-card-body>
</zc-card>
